import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Amount from "./walletusables/Amount";
import { toggleWithdrawFundsModal } from "../../redux/WalletSlice";
import WithdrawalDetails from "./walletusables/WithdrawalDetails";
import ConfirmWithdrawal from "./walletusables/ConfirmWithdrawal";
import { walletType, withdrawFundsFromWallet } from "../../screens/dashboard/DashboardUtils";
import PinComponent from "./PinComponent";
import SuccessModal from "../../components/SuccessModal";

const WithdrawalFlow = ({ activeWithdrawalTab, setActiveWithdrawalTab }) => {
	const dispatch = useDispatch();
	const { adminWallet, availableBanks } = useSelector((state) => state.wallet);

	const mainWallet = adminWallet?.find((wallet) => wallet?.product === walletType.main);

	const [withdrawalLoading, setWithdrawalLoading] = useState(false);

	const [withdrawalSuccess, setWithdrawalSuccess] = useState(null);

	const [paymentDetails, setPaymentDetails] = useState({
		amountToWithdraw: "",
		bankInfo: null,
	});
	const { amountToWithdraw, bankInfo } = paymentDetails;

	const handleChange = (e) => setPaymentDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }));

	const onCloseModal = () => {
		dispatch(toggleWithdrawFundsModal(false));
		setPaymentDetails({
			amountToWithdraw: "",
		});
	};

	const transactionFee = 50;
	const VAT = 7;

	const amount = Number(amountToWithdraw.replaceAll(",", ""));
	const totalFee = transactionFee + (VAT / 100) * 50;

	const totalAmount = amount + totalFee;

	const onProceedToConfirm = (details) => {
		setPaymentDetails((prev) => ({ ...prev, bankInfo: details }));
		setActiveWithdrawalTab(3);
	};

	const onProceedFromConfirm = () => {
		if (!amount) {
			toast.error("Amount to withraw cannot be less than N100");
			return;
		}
		if (!bankInfo?.accountNumber) {
			toast.error("Please add a recipient account");
			return;
		}
		if (mainWallet?.availableBalance < totalAmount) {
			toast.error("Your wallet balance is insufficient to perform this transaction");
			return;
		}

		setActiveWithdrawalTab(4);
	};

	const onDeductFromWallet = async () => {
		const details = {
			amount,
			accountNumber: bankInfo?.accountNumber,
			bankUUID: availableBanks?.find((bank) => bankInfo?.bankName.includes(bank?.name))?.uuid,
		};

		try {
			setWithdrawalLoading(true);
			const data = await withdrawFundsFromWallet(details);
			setWithdrawalSuccess(data);
		} catch (error) {
			console.log(error);
			toast.error(error);
		} finally {
			setWithdrawalLoading(false);
		}
	};

	useEffect(() => {
		if (withdrawalSuccess) {
			setActiveWithdrawalTab(5);
		} else {
			return;
		}
	}, [withdrawalSuccess]);

	return (
		<>
			{activeWithdrawalTab === 1 && (
				<Amount
					amount={amountToWithdraw}
					handleChange={handleChange}
					onCloseModal={onCloseModal}
					onProceed={() => setActiveWithdrawalTab(2)}
					context='Enter an amount to withdraw from your wallet'
					title='amountToWithdraw'
				/>
			)}
			{activeWithdrawalTab === 2 && (
				<WithdrawalDetails
					whiteBtnClick={() => setActiveWithdrawalTab(1)}
					onClose={onCloseModal}
					greenBtnClick={onProceedToConfirm}
				/>
			)}
			{activeWithdrawalTab === 3 && (
				<ConfirmWithdrawal
					whiteBtnClick={() => setActiveWithdrawalTab(2)}
					onClose={onCloseModal}
					amount={amount}
					fee={totalFee}
					total={totalAmount}
					balance={mainWallet?.availableBalance}
					greenBtnClick={onProceedFromConfirm}
					description='N/A'
					bankInfo={bankInfo}
				/>
			)}
			{activeWithdrawalTab === 4 && (
				<PinComponent
					onClose={() => setActiveWithdrawalTab(3)}
					onDeductFunds={onDeductFromWallet}
					isLoading={withdrawalLoading}
				/>
			)}
			{activeWithdrawalTab === 5 && (
				<SuccessModal
					modalText='Your withdrawal has been processed. The recipient account will be credited shortly.'
					btnText='okay'
					onReqClick={() => window.location.reload()}
				/>
			)}
		</>
	);
};

WithdrawalFlow.propTypes = {
	activeWithdrawalTab: PropTypes.number,
	setActiveWithdrawalTab: PropTypes.func,
};

export default WithdrawalFlow;
